import schemify from 'url-schemify/url-schemify';
import { useTranslation } from 'react-i18next';
import { UseFormTrigger } from 'react-hook-form';
import { Button } from '@react-md/button';
import { getBackendUrl } from '@services/axios-instance';
import { FeatureContent } from '@components/feature-content';
import { reverse } from '@utils';
import { SignInForm } from '../types';
import { signInId } from '../helpers';

interface Props {
    slug: string;
    email: string;
    trigger: UseFormTrigger<SignInForm>;
}

const getSsoReturnUrl = () => schemify(window.location.hostname + reverse('widgetUpload'), { scheme: 'https' });

export const SignInWithSso = ({ slug, email, trigger }: Props) => {
    const { t } = useTranslation();

    return (
        <form
            action={getBackendUrl(`/v2/sso/${slug}/initiate/`)}
            method="POST"
            onSubmit={async event => {
                const isValid = await trigger('email', { shouldFocus: true });
                if (!isValid) {
                    event.preventDefault(); // Prevent the default form submission
                }
            }}
        >
            <input type="hidden" name="email" value={email} />
            <input type="hidden" name="return_url" value={getSsoReturnUrl()} />

            <FeatureContent
                contentKey={signInId('sso')}
                fallback={t('buttons.signInSso', 'Sign in with SSO')}
                wrapper={props => (
                    <Button
                        className="rmd-button--text-large"
                        theme="primary"
                        themeType="outline"
                        type="submit"
                        {...props}
                    />
                )}
            />
        </form>
    );
};
